module.exports = __webpack_public_path__ + "static/media/home-heros.5180af10.jpg";